import React, { useState } from 'react';

import chevronDown from '@/public/images/icons/chevron-down.svg';

const ClientHubFaq = (props: {
  isMobile: boolean;
  activeSection: string;
  track: Function;
  scrollTo: Function;
  sitelinkId: string;
}) => {
  const { isMobile, activeSection, track, scrollTo, sitelinkId } = props;

  const id = 'faq';

  const showSection = () => {
    if (isMobile) return activeSection === id;
    return true;
  };

  const [expandReferrals, setExpandReferrals] = useState(false);
  const [expandAccessMyUnit, setExpandAccessMyUnit] = useState(false);
  const [expandStorageTips, setExpandStorageTips] = useState(false);
  const [expandItemsUnsafeToStore, setExpandItemsUnsafeToStore] =
    useState(false);
  const [expandProtectionPlan, setExpandProtectionPlan] = useState(false);
  const [expandMultipleCharges, setExpandMultipleCharges] = useState(false);
  const [expandLatePayment, setExpandLatePayment] = useState(false);
  const [expandMovingOut, setExpandMovingOut] = useState(false);
  const [expandFaqMultipleUnits, setExpandFaqMultipleUnits] = useState(false);
  const [expandFullTermsOfService, setExpandFullTermsOfService] =
    useState(false);

  return (
    <div style={{ display: showSection() ? 'block' : 'none' }}>
      <h3
        id="faq"
        style={{ textTransform: 'none', backgroundColor: 'aliceblue' }}
      >
        FAQs
      </h3>
      {/* --- */}
      <div onClick={() => setExpandReferrals(!expandReferrals)}>
        <b>
          {' '}
          Does Access Storage have a referral program?{' '}
          <img
            src={chevronDown.src}
            style={{ transform: expandReferrals ? 'rotateX(180deg)' : '' }}
            alt="chevron-down"
          />{' '}
        </b>
      </div>
      <div style={{ display: expandReferrals ? 'block' : 'none' }}>
        Yes! Send someone our way and get up to $100 through our referral
        program. It pays to be a good friend! <br />
        <ul>
          <li>
            Eligibility: both current and past clients are eligible to
            participate.
          </li>
          <li>
            Once your friend or family member moves into the unit you will be
            contacted to receive your reward.
          </li>
          <li>
            Rewards will be issued by prepaid credit card after the referral has
            moved into the unit and submitted all required documentation.
          </li>
          <li>
            Reward amount: <br />
            <table border={1} cellPadding={6} cellSpacing={0}>
              <thead>
                <tr>
                  <th style={{ minWidth: '4em' }}>Amount</th>
                  <th>Unit size</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>50$</td>
                  <td>0-100 sq ft & Outdoor Parking</td>
                </tr>
                <tr>
                  <td>75$</td>
                  <td>101-250 sq ft</td>
                </tr>
                <tr>
                  <td>100$</td>
                  <td>Larger than 250 sq ft</td>
                </tr>
              </tbody>
            </table>
            <i>*Restrictions may apply.</i>
          </li>
        </ul>
        <br />
      </div>
      {/* --- */}
      {/* --- */}
      <div onClick={() => setExpandAccessMyUnit(!expandAccessMyUnit)}>
        <b>
          {' '}
          When may I access my unit?{' '}
          <img
            src={chevronDown.src}
            style={{ transform: expandAccessMyUnit ? 'rotateX(180deg)' : '' }}
            alt="chevron-down"
          />{' '}
        </b>
      </div>
      <div style={{ display: expandAccessMyUnit ? 'block' : 'none' }}>
        Access and/or gate hours can be found in the{' '}
        <a
          href={'#'}
          onClick={(e) => {
            e.preventDefault();
            scrollTo('contact');
            return false;
          }}
          style={{ textDecoration: 'none' }}
        >
          Contact
        </a>{' '}
        section.
        <br /> <br />
      </div>
      {/* --- */}
      {/* --- */}
      <div onClick={() => setExpandStorageTips(!expandStorageTips)}>
        <b>
          {' '}
          How should I store my items?{' '}
          <img
            src={chevronDown.src}
            style={{ transform: expandStorageTips ? 'rotateX(180deg)' : '' }}
            alt="chevron-down"
          />{' '}
        </b>
      </div>
      <div style={{ display: expandStorageTips ? 'block' : 'none' }}>
        Here are some best practices to help you store with confidence:
        <ul>
          <li>Label your boxes clearly to make items easy to find.</li>
          <li>
            Cover mattresses and soft goods with plastic to protect from dust
            and moisture, but do not seal them air-tight. Always leave an
            opening for air to circulate.
          </li>
          <li>Keep your unit secure! Never share your access code or key.</li>
          <li>
            Make an inventory list and store it in a safe place for easy
            reference.
          </li>
          <li>
            Keep items off the floor, when possible, by using pallets or
            protective mats.
          </li>
        </ul>
        <br />
      </div>
      {/* --- */}
      {/* --- */}
      <div
        onClick={() => setExpandItemsUnsafeToStore(!expandItemsUnsafeToStore)}
      >
        <b>
          {' '}
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          Are there any items that I <u>can't</u> put in storage?{' '}
          <img
            src={chevronDown.src}
            style={{
              transform: expandItemsUnsafeToStore ? 'rotateX(180deg)' : '',
            }}
            alt="chevron-down"
          />{' '}
        </b>
      </div>
      <div style={{ display: expandItemsUnsafeToStore ? 'block' : 'none' }}>
        All food and edible items are strictly prohibited. Including, but not
        limited to, boxed, canned or perishable food items, pet food, and
        spices. These items can attract pests. By avoiding these in storage, we
        all help maintain a clean, pest-free environment.
        <br />
        <br />
        For your safety and compliance, storing the following items is
        prohibited:
        <br />
        <ul>
          <li>
            Living or organic items, such as plants/seeds, soil/fertilizer, pets
            or humans! (Please don’t sleep or stay in your unit for extended
            periods of time.)
          </li>
          <li>
            Anything requiring power or your long-term presence inside the unit.
          </li>
          <li>
            Items that may leak or cause damage to your unit or others. If
            storing a vehicle, ground covering is recommended.
          </li>
          <li>
            Flammable, toxic, or hazardous materials, such as gas, propane, or
            chemicals.
          </li>
          <li>Illegal items, including weapons, drugs, or stolen goods.</li>
        </ul>
        Violating these rules may result in immediate termination of your User
        Agreement.
        <br /> <br />
      </div>
      {/* --- */}
      {/* --- */}
      <div onClick={() => setExpandProtectionPlan(!expandProtectionPlan)}>
        <b>
          {' '}
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          What is the 'Protection Plan' all about?{' '}
          <img
            src={chevronDown.src}
            style={{
              transform: expandProtectionPlan ? 'rotateX(180deg)' : '',
            }}
            alt="chevron-down"
          />{' '}
        </b>
      </div>
      <div style={{ display: expandProtectionPlan ? 'block' : 'none' }}>
        Peace of mind comes standard! <br />
        <br />
        All unit rentals include automatic enrollment in our Protection Plan.
        This plan may include limited protection for risks like fire, theft, and
        certain types of water damage. If you have your own insurance, simply
        share proof with us to opt out. Protection limits range from $2,500 to
        $5,000 <br />
        <br />
        Claims must be submitted promptly with documentation and photographs.
        This plan is not a replacement for personal home or renter’s insurance.{' '}
        <br />
        <br />
        Review full details here:{' '}
        <a
          style={{ textDecoration: 'none' }}
          target="_blank"
          rel="noreferrer"
          onClick={() => track('Open terms of service')}
          href="https://tripemco.com/TripemcoSelfStorageWordings/TenantsWordingsLong.pdf#page=4"
        >
          Terms of Service
        </a>
        <br />
        <br />
      </div>
      {/* --- */}
      {/* --- */}
      <div onClick={() => setExpandMultipleCharges(!expandMultipleCharges)}>
        <b>
          Why do I see multiple rent charges on my invoice?
          <img
            src={chevronDown.src}
            style={{
              transform: expandMultipleCharges ? 'rotateX(180deg)' : '',
            }}
            alt="chevron-down"
          />{' '}
        </b>
      </div>
      <div style={{ display: expandMultipleCharges ? 'block' : 'none' }}>
        Your account is billed every 4 weeks from your move-in date. You may see
        upcoming rent cycles listed on your statement or in your online account
        — this is normal and meant for visibility. <br />
        <br />
        We can also pro-rate your rent by the week if you will not use the unit
        for the entire cycle. Please contact us before the next due date to
        organize your payment. <br />
        <br />
        Important: You only need to pay for your current billing cycle. Any{' '}
        {/* eslint-disable-next-line react/no-unescaped-entities */}
        future rent charges shown are not yet due. If you'd like to pay ahead,{' '}
        {/* eslint-disable-next-line react/no-unescaped-entities */}
        you're welcome to — but it's not required.
        <br /> <br />
      </div>
      {/* --- */}
      {/* --- */}
      <div onClick={() => setExpandLatePayment(!expandLatePayment)}>
        <b>
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          What happens if I'm late making a payment?{' '}
          <img
            src={chevronDown.src}
            style={{ transform: expandLatePayment ? 'rotateX(180deg)' : '' }}
            alt="chevron-down"
          />{' '}
        </b>
      </div>
      <div style={{ display: expandLatePayment ? 'block' : 'none' }}>
        The best way to keep your account current is to enroll in pre-authorized
        payment. You can sign up via our secure client portal:{' '}
        <a
          style={{ textDecoration: 'none' }}
          target="_blank"
          rel="noreferrer"
          onClick={() => track('Open MyAccount')}
          href={`https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=${sitelinkId}==&1=1`}
        >
          My Account
        </a>{' '}
        <br />
        <br />
        <table border={1} cellPadding={6} cellSpacing={0}>
          <thead>
            <tr>
              <th style={{ minWidth: '4em' }}>Day</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Day 3</td>
              <td>A late fee of 5% (minimum $5) is added to the account.</td>
            </tr>
            <tr>
              <td>Day 5</td>
              <td>
                Access is temporarily paused to the unit and the property.
              </td>
            </tr>
            <tr>
              <td>Day 9</td>
              <td>
                An additional late fee of 5% (minimum $5) is added to the
                account.
              </td>
            </tr>
            <tr>
              <td>Day 15</td>
              <td>
                An additional late fee of 5% (minimum $5) is added to the
                account.
              </td>
            </tr>
            <tr>
              <td>Day 21</td>
              <td>
                An additional late fee of 5% (minimum $5) is added to the
                account.
              </td>
            </tr>
            <tr>
              <td>Day 31</td>
              <td>
                We begin auction preparation by photographing the unit{' '}
                {/* eslint-disable-next-line react/no-unescaped-entities */}
                contents. If payment is made after this point, you'll just need
                to replace the lock.
              </td>
            </tr>
            <tr>
              <td>Day 45</td>
              <td>
                A lien fee equal to one rent cycle will be added, and you’ll
                need to pay the full balance before the auction date to retain
                your unit.
              </td>
            </tr>
            <tr>
              <td>Day 90</td>
              <td>
                If no payment has occurred, the unit is considered abandoned and
                the unit contents will be auctioned.
              </td>
            </tr>
          </tbody>
        </table>
        <br /> <br />
      </div>
      {/* --- */}
      {/* --- */}
      <div onClick={() => setExpandMovingOut(!expandMovingOut)}>
        <b>
          {' '}
          What do I need to do when I’m moving out?{' '}
          <img
            src={chevronDown.src}
            style={{ transform: expandMovingOut ? 'rotateX(180deg)' : '' }}
            alt="chevron-down"
          />{' '}
        </b>
      </div>
      <div style={{ display: expandMovingOut ? 'block' : 'none' }}>
        Your rental is fully flexible! <br />
        <br />
        If you only need the unit for part of your next cycle, just let us know
        before the start of the next billing cycle. We’ll gladly assist you with
        a one-time, pro-rated rent payment. <br />
        <br />
        Refunds are available only if you’ve moved out before the rental’s due
        date. Please take all items with you at move-out, remove the lock from
        your unit and notify our Team once you’re done. A disposal fee of $50 to
        $500 will apply if items are left behind after move-out. <br />
        <br />
      </div>
      {/* --- */}
      {/* --- */}
      <div onClick={() => setExpandFaqMultipleUnits(!expandFaqMultipleUnits)}>
        <b>
          {' '}
          What if I have more than one unit?{' '}
          <img
            src={chevronDown.src}
            style={{
              transform: expandFaqMultipleUnits ? 'rotateX(180deg)' : '',
            }}
            alt="chevron-down"
          />{' '}
        </b>
      </div>
      <div style={{ display: expandFaqMultipleUnits ? 'block' : 'none' }}>
        If you have more than one unit with us, you can see and manage all your
        units in one place. <br />
        <br />
        Visit our secure client portal:{' '}
        <a
          style={{ textDecoration: 'none' }}
          target="_blank"
          rel="noreferrer"
          onClick={() => track('Open MyAccount')}
          href={`https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=${sitelinkId}==&1=1`}
        >
          My Account
        </a>{' '}
        <br />
        <br />
        Once logged in:
        <ol>
          <li>A list of all your units will be available.</li>
          <li>Select one of your units</li>
          <li>
            From this point forward, follow the same steps outlined in the
            Payments and/or Access section
          </li>
        </ol>
        <br />
      </div>
      {/* --- */}
      {/* --- */}
      <div
        onClick={() => setExpandFullTermsOfService(!expandFullTermsOfService)}
      >
        <b>
          {' '}
          Full terms of service{' '}
          <img
            src={chevronDown.src}
            style={{
              transform: expandFullTermsOfService ? 'rotateX(180deg)' : '',
            }}
            alt="chevron-down"
          />{' '}
        </b>
      </div>
      <div style={{ display: expandFullTermsOfService ? 'block' : 'none' }}>
        While we take every precaution to maintain a safe and secure
        environment, we encourage you to review your User Agreement terms for
        details on responsibility and coverage.{' '}
        <a
          style={{ textDecoration: 'none' }}
          target="_blank"
          rel="noreferrer"
          onClick={() => track('Open terms of service')}
          href="https://www.accessstorage.ca/en/terms-of-service/"
        >
          Terms of Service
        </a>
        .
        <br /> <br />
      </div>
      {/* --- */}
      <hr />
    </div>
  );
};

export default ClientHubFaq;
